import { Button } from "@mui/material";
import React from "react";
import Setting from "../../image/Setting.svg";
import Alert from "../../image/Alert.svg";
import { Link } from "react-router-dom";

const MailIcon = (props) => {
  function logout() {
    props.state.keycloak.logout();
  }

  return (
    <div>
      {!!JSON.parse(localStorage.getItem("UserDetails")).groups.find(
        (val) => val === "/formsflow/formsflow-designer"
      ) && (
        <Link to="/settings">
          <Button className="Settings">
            <img src={Setting} alt="Settings" width="20" />
          </Button>
        </Link>
      )}
      <Button className="Settings">
        <img src={Alert} alt="AlertIcon" width="20" />
      </Button>

      <Button
        className="AccountHolder Settings btn"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {JSON.parse(
          localStorage.getItem("UserDetails")
        ).preferred_username.slice(0, 1)}
      </Button>
      <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <span className="dropdown-item">user</span>
        <hr />
        <span onClick={logout} className="dropdown-item">
          Logout
        </span>
      </div>
    </div>
  );
};

export default MailIcon;
